import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MapLocation } from 'src/app/core/models/shared/MapLocation';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';

@Component({
  selector: 'profile-company-location',
  templateUrl: 'profile-company-location.component.html',
})
export class ProfileCompanyLocationComponent
  extends BaseComponent
  implements OnInit
{
  @Input() form: FormGroup;

  ngOnInit(): void {
    this.form.addControl(
      'Location',
      new FormControl(null, Validators.required)
    );
  }
}
